import React from 'react';
import logo from '../Header/fitinsur-logo.svg';

import { Wrapper, Container, Environment } from './styles';

export default function TopHeader() {
  return (
      <>
      {process.env.REACT_APP_ENVIRONMENT && process.env.REACT_APP_ENVIRONMENT != "texel-connexion" && process.env.REACT_APP_ENVIRONMENT != "production" ?  
      (
        <Wrapper>
          <Container>
            <Environment>
              Ambiente de Teste - {process.env.REACT_APP_ENVIRONMENT}
            </Environment>
          </Container>
        </Wrapper>
      ) : null }
      </>
  );
}
